$(document).ready(function () {

	$('.mobile-wrap').on('click', function () {
		$('.line-burger').toggleClass('line-active');
		$('.header__list').slideToggle();
	});

	$(window).resize(function () {
		if ($(window).width() > 1023) {
			$('.header__list').attr('style', '');
			$('.line-burger').removeClass('line-active');
		}
	});

	const sliderElement = document.querySelector('.solution__slider');

	if (sliderElement) {
		new Swiper(".solution__slider", {
			pagination: {
				el: ".solution__holder .swiper-pagination",
				clickable: true,
			},
			navigation: {
				nextEl: ".solution__holder .swiper-button-next",
				prevEl: ".solution__holder .swiper-button-prev",
			},
		});
	}

	function validate(input, length, regExp, error, phone) {

		$(input).on('blur keyup', function () {
			var value = $(this).val();
			var that = $(this);

			regExp = regExp == '' ? /./ : regExp;

			if (phone === true) {
				bool_reg = !regExp.test(value);
			} else {
				bool_reg = regExp.test(value);
			}

			if (value.length > length && value !== '' && bool_reg) {
				that.removeClass('form-fail').addClass('form-done');
				$(error).slideUp();
			} else {
				that.removeClass('form-done').addClass('form-fail');
				$(error).slideDown();
			}
		});
	}

	// деакцивация кнопки если есть поле с ошибкой

	function disBtn(input, btn, bool) {
		var input = $(input);
		input.on('blur keyup', function () {

			if (input.hasClass('form-fail') || bool == true) {
				$(btn).attr('disabled', 'disabled');
			} else {
				$(btn).removeAttr('disabled');
			}

		});
	}

	// для проверки при нажатии

	function valClick(input, length, regExp, error, phone) {
		var value = $(input).val();

		regExp = regExp == '' ? /./ : regExp;

		if (phone === true) {
			bool_reg = regExp.test(value);
		} else {
			bool_reg = !regExp.test(value);
		}

		if (value.length < length || value === '' || bool_reg) {
			$(input).addClass('form-fail');
			$(error).slideDown();
		}
	}

	//  деакцивация кнопки при нажатии

	function disBtnClick(input, btn) {
		var input = $(input);

		if (input.hasClass('form-fail')) {
			$(btn).attr('disabled', 'disabled');
			return false;
		} else {
			return true;
		}
	}

	var regName = /^[a-zA-Zа-яА-ЯёЁIiЇї]+/;
	var regEmail = /[-.\w]+@[-.\w]+\.[-.\w]+/i;

	$('#r_btn').on('click', function () {
		sendForm();
		return false;
	});

	function sendForm() {
		var name = $('#r_name').val();
		var email = $('#r_email').val();
		var msg = $('#r_msg').val();

		validate('#r_name', 1, regName, '.request__error--name');
		validate('#r_email', 1, regEmail, '.request__error--email');
		disBtn('#r_name, #r_email', '#r_btn');

		valClick('#r_name', 1, regName, '.request__error--name');
		valClick('#r_email', 1, regEmail, '.request__error--email');
		var btn_bool = disBtnClick('#r_name, #r_email', '#r_btn');

		if (btn_bool) {
			$.ajax({
				url: themeVar.url,
				type: 'POST',
				data: {
					action: 'contact',
					name: name,
					email: email,
					msg: msg,
				},
			}).done(function (data) {
				$('#r_name, #r_email, #r_msg').val('').removeClass('form-done');
				var text = 'Ваше повідомлення відправлене!';

				$('.msg-modal').html(text).addClass('msg-modal-active');
				setTimeout(function () {
					$('.msg-modal').removeClass('msg-modal-active');
				}, 2500);
			});
		}
	}
});

$(document).on('click', '.header__link, .header .btn, .build__btn', function () {
	let target = $(this).attr('href');
	let pos = target.indexOf('#');
	if (pos !== -1) {
		target = target.substring(pos);
		let coordsScroll = $(target).offset().top;
		$('html, body').animate({
			scrollTop: coordsScroll
		}, 800);
		if ($(window).width() < 768 && $(this).hasClass('header__link')) {
			$('.header__list').slideUp();
			$('.line-burger').removeClass('line-active');
		}
		return false;
	}
});
